import { Territory } from '../types'
import { SearchParams, TerritoriesActions, territoriesTypes, TerritoryType } from './types'

const actions = {
  fetchTerritories: (
    payload: {
          page?: number,
          size?: number,
          searchParams?: Partial<SearchParams>
    },
    callback: (succ: boolean) => void
  ): TerritoriesActions => ({
    type: territoriesTypes.FETCH_TERRITORIES,
    payload,
    callback
  }),
  setTerritories: (payload: TerritoryType[]): TerritoriesActions => ({
    type: territoriesTypes.SET_TERRITORIES,
    payload
  }),
  fetchTerritorySuccessManagers: (
    callback: (succ: boolean) => void
  ): TerritoriesActions => ({
    type: territoriesTypes.FETCH_TERRITORY_MANAGERS,
    payload: {},
    callback
  }),
  setTerritorySuccessManagers: (payload: TerritoryType[]): TerritoriesActions => ({
    type: territoriesTypes.SET_TERRITORIES,
    payload
  }),
  createTerritory: (
    payload: Partial<Territory>,
    callback: (succ: boolean) => void
  ): TerritoriesActions => ({
    type: territoriesTypes.CREATE_TERRITORY,
    payload,
    callback
  }),
}

export default actions
